import { render } from "./TrendsPage.vue?vue&type=template&id=75c59e6a"
import script from "./TrendsPage.vue?vue&type=script&lang=js"
export * from "./TrendsPage.vue?vue&type=script&lang=js"

import "./TrendsPage.vue?vue&type=style&index=0&id=75c59e6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__